import { createSlice } from "@reduxjs/toolkit";
import { InitialState } from "./models";
import * as Actions from "../actions";
import { dataComprovantesReducer } from "../reducers";

const initialState: InitialState = {
  dataComprovantes: {
    data: [],
    isLoading: false,
  },
  configTabs: {
    tabInView: 0,
    tabs: [
      {
        title: "Comprovantes de entrega",
        index: 0,
        active: true,
        name: "comprovantes",
      },
    ],
  },
};

const comprovantesSlice = createSlice({
  name: "comprovantesApp/comprovantes",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(Actions.getComprovante.pending, (state) => {
      state.dataComprovantes.isLoading = true;
    });
    builder.addCase(Actions.getComprovante.rejected, (state) => {
      state.dataComprovantes.isLoading = false;
    });
    builder.addCase(Actions.getComprovante.fulfilled, dataComprovantesReducer);
  },
});

export default comprovantesSlice.reducer;
